module.exports = "/_next/static/images/wirelessCom3-d26f46ba353693462f48445509ff8598.webp";